module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"My automations","goToAutomations":"Go to automations","templateCreated":"Shared template created.","templateAction":"Go to templates","saved":"All changes saved.","eHawkModalTitle":"Before you create automations, tell us about your business"}}')
  delete Component.options._Ctor
}
